import * as React from 'react';
import {
  CVIActionType,
  GetCVIBrandsStartAction,
  SelectCVITypeAction,
  SaveCVISuccessAction,
  SaveCVIFailureAction,
  SaveCVIStartAction,
  LoadCVIForEditAction,
  SetMultipleUnitPropertyTypesAction
} from './cvi.actions';
import { OptionsViewModel } from '@models/common.models';
import { createReducer } from '@common/redux-utils';
import { ToastComponent, ToastType } from '@common/components';
import { ToastOptions } from '@common/components/toast/toast';
import { toast } from 'react-toastify';
import { AuthorizationPromptViewModel } from '@models/AuthorizationPrompt';
import { PropertyTypeViewModel } from '@models/Contract';

export interface CVIState {
  brands: OptionsViewModel[];
  selectedCVIId?: number;
  selectedCVIIsBrandable?: boolean;
  readonly prompts: Array<AuthorizationPromptViewModel>;
  readonly multipleUnitPropertyTypes: Array<PropertyTypeViewModel>;
}

const initialCVIState = {
  brands: [],
  selectedCVIId: undefined,
  selectedCVIIsBrandable: undefined,
  prompts: [],
  multipleUnitPropertyTypes: []
};

function handleGetBrandsStart(state: CVIState, action: GetCVIBrandsStartAction) {
  return {
    ...state
  };
}

function handleGetBrandsSuccess(state: CVIState, action: GetCVIBrandsStartAction) {
  return {
    ...state
  };
}

function handleGetBrandsFailure(state: CVIState, action: GetCVIBrandsStartAction) {
  return {
    ...state
  };
}

function handleSelectCVIType(state: CVIState, action: SelectCVITypeAction) {
  return {
    ...state,
    selectedCVIId: action.id,
    selectedCVIIsBrandable: action.isBrandable
  };
}

function handleCVISaveStart(state: CVIState, action: SaveCVIStartAction) {
  return {
    ...state
  };
}

function handleCVISaveSuccess(state: CVIState, action: SaveCVISuccessAction) {
  toast.success(<ToastComponent type={ToastType.Success} message={`CVI Saved Successfully`} />, ToastOptions.Success);
  return {
    ...state
  };
}

function handleCVISaveFailure(state: CVIState, action: SaveCVIFailureAction) {
  toast.error(<ToastComponent type={ToastType.Error} message={`CVI Failed to Save`} />, ToastOptions.Error);
  return {
    ...state
  };
}

function handleLoadCVIForEdit(state: CVIState, action: LoadCVIForEditAction) {
  return {
    ...state
  };
}

function handleSetMultipleUnitPropertyTypes(state: CVIState, action: SetMultipleUnitPropertyTypesAction): CVIState {
  return {
    ...state,
    multipleUnitPropertyTypes: action.multipleUnitPropertyTypes
  };
}

export const CVIReducer = createReducer<CVIState, CVIActionType>(initialCVIState, {
  [CVIActionType.CVIGetBrandsStart]: handleGetBrandsStart,
  [CVIActionType.CVIGetBrandsSuccess]: handleGetBrandsSuccess,
  [CVIActionType.CVIGetBrandsFailure]: handleGetBrandsFailure,
  [CVIActionType.CVISelectType]: handleSelectCVIType,
  [CVIActionType.SaveCVIStart]: handleCVISaveStart,
  [CVIActionType.SaveCVISuccess]: handleCVISaveSuccess,
  [CVIActionType.SaveCVIFailure]: handleCVISaveFailure,
  [CVIActionType.LoadCVIForEdit]: handleLoadCVIForEdit,
  [CVIActionType.SetMultipleUnitPropertyTypes]: handleSetMultipleUnitPropertyTypes
});



// WEBPACK FOOTER //
// ./src/service-work-order/cvi/cvi.reducer.tsx